module.exports = __webpack_public_path__ + "img/winner.19a38d52.jpg";